module.exports = __webpack_public_path__ + "static/img/function2.a3a382b7.png";